/**
 * Formulaire de contact
 */
jQuery(window).on('elementor/frontend/init', function () {
  const $ = jQuery;

  // Listen for all Elementor form AJAX calls
  $(document).ajaxComplete(function (event, xhr, settings) {
    console.log('event, xhr, settings', event, xhr, settings);

    try {
      const response = xhr.responseJSON;
      console.log('Parsed AJAX response:', response);
      if (!response.success) {
        console.error('❌ Elementor form error:', response);

        const errors = response.data?.errors || {};
        const $form = $('.elementor-form');

        // Remove old messages
        $form.find('.error-message').remove();
        $form.find('.elementor-message').remove();
        console.log('Old error messages removed, ready to display new ones.');

        // Loop over errors and display inline messages
        for (const field in errors) {
          if (!errors[field]) continue;

          // Example: gender
          console.log('Error field:', field, 'Message:', errors[field]);
          const $fieldGroup = $form.find(`.elementor-field-group-${field}`);
          if ($fieldGroup.length) {
            $fieldGroup.append(`<div class="error-message">${errors[field]}</div>`);
          } else {
            // fallback — generic error message
            $form
              .find('.elementor-message')
              .removeClass('elementor-message-success')
              .addClass('elementor-message-danger')
              .text(response.data.message || 'Une erreur est survenue.');
          }
        }
      }
    } catch (err) {
      // not Elementor form or invalid JSON
    }
  });

  // still handle success normally
  $(document).on('submit_success', '.elementor-form', function (event, response) {
    console.log('✅ Success:', response);

    try {
      if (!response.success) {
        console.error('❌ Elementor form error:', response);

        const errors = response.data?.errors || {};
        const $form = $('.elementor-form');

        // Remove old messages
        $form.find('.error-message').remove();
        $form.find('.elementor-message').remove();
        console.log('Old error messages removed, ready to display new ones.');

        // Loop over errors and display inline messages
        for (const field in errors) {
          if (!errors[field]) continue;

          // Example: gender
          console.log('submit_success error field:', field, 'Message:', errors[field]);

          const $fieldGroup = $form.find(`.elementor-field-group-${field}`);
          if ($fieldGroup.length) {
            $fieldGroup.append(`<div class="error-message">${errors[field]}</div>`);
          } else {
            // fallback — generic error message
            $form
              .find('.elementor-message')
              .removeClass('elementor-message-success')
              .addClass('elementor-message-danger')
              .text(response.data.message || 'Une erreur est survenue.');
          }
        }
      } else {
        // Remove old messages
        $form.find('.error-message').remove();
        $('.elementor-message').show();
      }
    } catch (err) {
      // not Elementor form or invalid JSON
    }
  });

  $(document).on('load', 'form select', function (event, response) {
    console.log('event, response', event, response);
  });
  $('form select').select2({
    placeholder: 'Select an option',
    // dropdownParent: $('form select'),
  });
  $('form select').val(null).trigger('change');
});

jQuery(document).ready(function ($) {
  const $privacyCheckbox = $('.formulaire_de_contact_field_privacy');
  // Handle Checkboxes
  $privacyCheckbox.addClass('elementor-mark-required');
  $privacyCheckbox.find('input').attr('required', 'required');
});
